import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import {
  checkSavedDraftSaga,
  createDraftSaga,
  getDraftSaga,
  refineDraftSaga,
  saveDraftAndExitSaga,
  updateCurrentDraftSaga,
  updateDraftSaga,
  updateXmlDraftSaga,
} from './draftSagas';
import { initializeSaga } from './initializeSagas';
import { receiptsSaga } from './receiptsSaga';
import {
  getParentDeclarationByYearSaga,
  initialDataSaga,
  submitInitialDataSaga,
} from '../components/InitialData/sagas';
import { getNdfl2ByYearSaga, initIncomesSaga } from '../components/Incomes/sagas';
import { initDeclarationSubmitSaga, submitDeclarationSubmitSaga } from '../components/Submit/sagas';
import { initOverpaymentsSaga, submitOverpaymentsSaga } from '../components/Overpayments/sagas';

export function* NDFL3LightSaga() {
  yield takeEvery(actionTypes.CREATE_DRAFT, createDraftSaga);
  yield takeEvery(actionTypes.REFINE_DRAFT, refineDraftSaga);
  yield takeEvery(actionTypes.UPDATE_DRAFT, updateDraftSaga);
  yield takeEvery(actionTypes.GET_DRAFT, getDraftSaga);
  yield takeEvery(actionTypes.SAVE_DRAFT_AND_EXIT, saveDraftAndExitSaga);

  yield takeEvery(actionTypes.UPDATE_XML_DRAFT, updateXmlDraftSaga);

  // Short script initialize sagas
  yield takeEvery(actionTypes.INITIALIZE, initializeSaga);

  // InitialData Step sagas
  yield takeEvery(actionTypes.INITIAL_DATA, initialDataSaga);
  yield takeEvery(actionTypes.GET_PARENT_DECLARATION_BY_YEAR, getParentDeclarationByYearSaga);
  yield takeEvery(actionTypes.SUBMIT_INITIAL_DATA, submitInitialDataSaga);

  // Incomes step sagas
  yield takeEvery(actionTypes.INCOMES_DATA, initIncomesSaga);
  yield takeEvery(actionTypes.GET_NDFL2_BY_YEAR, getNdfl2ByYearSaga);

  // Submit step sagas
  yield takeEvery(actionTypes.SUBMIT_DATA, initDeclarationSubmitSaga);
  yield takeEvery(actionTypes.SUBMIT_DECLARATION, submitDeclarationSubmitSaga);

  // Receipts sagas
  yield takeEvery(actionTypes.SET_RECEIPTS_LINK, receiptsSaga);

  // Check existing drafts
  yield takeEvery(actionTypes.GET_SAVED_DRAFTS, checkSavedDraftSaga);

  // Update current draft
  yield takeEvery(actionTypes.UPDATE_CURRENT_DRAFT, updateCurrentDraftSaga);

  // Overpayments step sagas
  yield takeEvery(actionTypes.OVERPAYMENTS_DATA, initOverpaymentsSaga);
  yield takeEvery(actionTypes.OVERPAYMENTS_SUBMIT_DATA, submitOverpaymentsSaga);
}
